<!--设备管理-视频管理 列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >
      <!--      列表表格-->
      <div>
        <a-button type="primary" html-type="button" @click="toAddPage">
          新增
        </a-button>
        <a-table :pagination="pagination" @change="handleTableChange" :columns="columns" :data-source="data" >

          <span slot="action" slot-scope="text, record">

            <a @click="toEditPage(record)">修改</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteModal">删除</a>
            <a-divider type="vertical" class="sline" />
            <a @click="showRelodVideo(record)" v-show="isShow">加载视频</a>
            <span v-show="isShowLoading"><img src="../../../img/213476703.gif" width="40" /></span>
          </span>
        </a-table>
      </div>
    </a-card>
    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleOk" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>
    <!-- 重新加载视频确认框 -->
    <a-modal v-model="showRelodVisible" title="重新加载视频" @ok="handleOkLoadVideo" ok-text="确认" cancel-text="取消">
      <p>您确定要重新加载视频？加载过程中请不要重复刷新页面或按钮！</p>
    </a-modal>

  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'

 const columns = [
    {
      title: '序列号',
      dataIndex: 'cDeviceSN',
      key: 'cDeviceSN',
      ellipsis: true,
    },
   {
     title: '场地名称',
     dataIndex: 'cSceneName',
     key: 'cSceneName',
     ellipsis: true,
   },
   {
     title: '设备名称',
     dataIndex: 'cDeviceName',
     key: 'cDeviceName',
     ellipsis: true,
   },
   {
     title: '设备别名',
     dataIndex: 'cDeviceAsName',
     key: 'cDeviceAsName',
     ellipsis: true,
   },
   {
     title: '设备地址',
     dataIndex: 'AddressType',
     key: 'AddressType',
     ellipsis: true,
   },
   {
     title: 'AppKey',
     dataIndex: 'AppKey',
     key: 'AppKey',
     ellipsis: true,
   },
   {
     title: 'AppSecret',
     dataIndex: 'AppSecret',
     key: 'AppSecret',
     ellipsis: true,
   },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];



  export default {
    name: 'videoManagement',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1:"设备管理",
        titleMsg2:'视频管理',
        titleMsg3:'视频管理',
        data:[
            {
              cDeviceSN:'',
               cSceneName:'',
               cDeviceName:'',
               cDeviceAsName:'',
               AddressType:'',
               AppKey:'',
               AppSecret:'',


            }
            //  {
            //   cDeviceSN:'244134802',
            //    cSceneName:'青岛海洋渔场黄岛',
            //    cDeviceName:'DS-8616N-E8-V2',
            //    cDeviceAsName:'办公楼球机',
            //    AddressType:'数据展示',
            //    AppKey:'bfb519fc800146d2',
            //    AppSecret:'6f77bb1c80b6238d',


            // }
        ],
        columns,
        record:{},
        zhibodata:{},
        deleteModalVisible:false,
        showRelodVisible: false,
        isShow:true,
        isShowLoading:false,
        paramas:{
          cSceneID:"",
          cEntID:'',
          page:1,
          limit:10
        },
        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
      }
    },
    mounted () {
let that=this;

      that.paramas.cSceneID=that.$store.getters.SCene.ID;
      that.paramas.cEntID=that.$store.getters.User.enterprise.ID;
      that.handlePageList();
      that.$bus.$on('scenechange',(target)=> {
        that.paramas.cSceneID=target.id;
      that.handlePageList();
      });

    },
    methods:{
      toAddPage(){
        this.$router.push({path:'/equipmentManagement/videoManagement/videoManagementForm'});

      },

     async zhibo(record){
        let that=this;
        let param={};

        record.cDeviceSN='E38872425';
        param.deviceSerial=record.cDeviceSN;
        param.channelNo=record.cChannelNo;
        param.ID=record.ID
        let res= await that.$http.post('HkCamera/GetZhibo?ID='+ param.ID+'&deviceSerial='+param.deviceSerial+'&channelNo='+param.channelNo,null)

        if(res.data.code=="200"){

          that.zhibodata= res.data.message;
          console.log(res)

        }
        else{
          that.$message.error(res.message)

        }

      },
      handleOk:function () {
        // this.$router.push('/')
        this.deleteModalVisible=false
      },
      handleTableChange(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.paramas.page = pagination.current;
        this.paramas.limit = pagination.pageSize;
        this.handlePageList();
      },
      async handlePageList(){

        let that=this;that.paramas.cSystemCode='节水灌溉'
        console.log(that.paramas);
        //return;
        let res= await that.$http.post('HkCamera/PageList',that.paramas)

        if(res.data.code=="200"){

          that.data= res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },

      //删除
      async handleDelete(){
        let that=this;
        let param=null;
        let res=await that.$http.post('HkCamera/Delete?accessToken='+that.paramas.accessToken+'&deviceSerial='+that.record.cDeviceSN,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.handlePageList();
        }
        else{
          that.$message.error(res.data.message)

        }
      },
      //查询经纬度

      //新增

      //修改
      toEditPage(obj){
        let that=this;
        this.$router.push({name:'VideoManagementForm',params:{ID:obj.ID}});
      },

      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true;
      },
      //重新加载视频
      showRelodVideo: function (obj) {
        this.record = obj
        this.showRelodVisible = true
      },

      //确定重新加载
      async handleOkLoadVideo()
      {
        const that = this;
        this.showRelodVisible = false;
        this.isShow = false;
        this.isShowLoading = true;
        //console.log(that.record.cEntID);
        console.log(that.record);
        //return;
        const res = await that.$http.post('HkCamera/CameraList', that.record)
        //console.log(res);
        if (res.data.code == '200') {
          that.$message.success("已经加载成功！")
        } else {
          that.$message.error(res.data.message);
        }
        this.isShow = true;
        this.isShowLoading = false;
      }
    }
  }
</script>
